import * as uiConsts from './consts';

const getMobileLangSelector = () => {
  const langFrag = document.createDocumentFragment();
    const langSelectElm = document.createElement('select');
    const langMenuElm = document.querySelector('.lang-mobile');

  Array.prototype.slice
    .call(document.querySelectorAll('.lang-menu li a'))
    .forEach(e => {
      langSelectElm.options.add(
        new Option(e.innerHTML, e.getAttribute('data-culture'))
      );
    });

  langSelectElm.classList.add('mobileSelect', 'mobilelanguageSelect');
  langFrag.appendChild(langSelectElm);
  langMenuElm.appendChild(langFrag);

  return langMenuElm;
};

const getMobileRegionSelector = () => {
  const regionSelector = document.querySelector('.top-nav__region-wrapper');
    const regionSelectElm = document.createElement('select');
    const regMenuElm = document.querySelector('.region-mobile');
    const regFrag = document.createDocumentFragment();

  Array.prototype.slice
    .call(regionSelector.querySelectorAll('li a'))
    .forEach(e => {
      regionSelectElm.options.add(new Option(e.innerHTML, e.href));
    });

  regionSelectElm.options[0].selected = true;

  regionSelectElm.classList.add('mobileSelect', 'mobileregionSelect');
  regFrag.appendChild(regionSelectElm);
  regMenuElm.appendChild(regFrag);
  return regMenuElm;
};

const getMobileLogin = () => {
  const wartsilaOnline = document.querySelector('.top-nav__login a');
  const mobileWartsila = wartsilaOnline.cloneNode(true);
  mobileWartsila.classList.add('mobile-login');
  return mobileWartsila;
};

const getMobileSearch = () => {
  const searchSelector = document.querySelector('.search-input--small');
  if(searchSelector){
    const mobileSearch = searchSelector.cloneNode(true);
    mobileSearch.classList.remove('display__desktop-only');
    mobileSearch.classList.add('display__mobile-only');
  
    var input = mobileSearch.querySelector('input')
    var inputId = input.getAttribute('id');
    input.setAttribute('id', 'mobile-' + inputId);
  
    var searchIcon = mobileSearch.querySelector('i')
    var searchIconId = searchIcon.getAttribute('id');
    searchIcon.setAttribute('id', 'mobile-' + searchIconId);
  
    return mobileSearch;
  }

  return null;
};

export const getMobileNav = () => {
  const menuLinks = document.querySelectorAll('[class^=main-nav__nav-link]');
  const secondaryLinks = document.querySelectorAll(
    '[class^=top-nav-bar__nav-link]'
  );

  console.log('mobile nav ' + menuLinks.length)
  if (!(menuLinks && menuLinks.length > 0)) {
    return;
  }

  if(getMobileSearch() !== null){
    uiConsts.NAV_MOBILE.appendChild(getMobileSearch());
  }

  Array.prototype.slice.call(menuLinks).forEach(e => {
    uiConsts.NAV_MOBILE.appendChild(e.cloneNode(true));
  });
  Array.prototype.slice.call(secondaryLinks).forEach(e => {
    uiConsts.NAV_MOBILE.appendChild(e.cloneNode(true));
  });

  const node = document.createElement('div');
  node.classList.add('mobile-actions-wrapper');

  node.appendChild(getMobileLangSelector());
  node.appendChild(getMobileRegionSelector());
  node.appendChild(getMobileLogin());

  return uiConsts.NAV_MOBILE.appendChild(node.cloneNode(true));
};
